<template>
  <div class="electrovalence">
    <div class="title">
      <p>
        <span @click="goBack">电价配置</span>
      </p>
    </div>
    <div class="content">
      <!--数据列表内容-->
      <div class="contain">
        <!--新增电价-->
        <el-button class="addBtn" type="primary" @click="addClick">
          <el-icon>
            <Plus/>
          </el-icon>
          新增电价
        </el-button>
        <!--电价列表-->
        <el-table v-loading="loading" :data="tableData" style="width: 100%">
          <template #empty>
            <el-empty class="emptyClass" description="暂无数据信息"
                      image="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/emptyImg.png">
              <p>您可以在此页面新增电价</p>
            </el-empty>
          </template>
          <el-table-column label="版本号" prop="versionNumber" width="100px"></el-table-column>
          <el-table-column label="生效日期" prop="">
            <template #default="scope">
              <p>{{ scope.row.startTime }} {{ scope.row.startTime ? '-' : '' }} {{ scope.row.endTime }}</p>
            </template>
          </el-table-column>
          <el-table-column label="尖费率" prop="sharpRateList">
            <template #default="scope">
              <p v-for="(item,index) in scope.row.sharpRateList" :key="index">{{ item }}</p>
            </template>
          </el-table-column>
          <el-table-column label="峰费率" prop="sharpRateList">
            <template #default="scope">
              <p v-for="(item,index) in scope.row.peakRateList" :key="index">{{ item }}</p>
            </template>
          </el-table-column>
          <el-table-column label="平费率" prop="sharpRateList">
            <template #default="scope">
              <p v-for="(item,index) in scope.row.flatRateList" :key="index">{{ item }}</p>
            </template>
          </el-table-column>
          <el-table-column label="谷费率" prop="sharpRateList">
            <template #default="scope">
              <p v-for="(item,index) in scope.row.valleyRateList" :key="index">{{ item }}</p>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作">
            <template #default="scope">
              <!--              <span class="btn" @click="lookClick(scope.row.id)">详情</span>-->
              <!--              <span class="btn" @click="editClick(scope.row.id)">编辑</span>-->
              <!--              <span class="btn" @click="delClick(scope.row.id)">删除</span>-->
              <div class="opacity">
                <span class="btn" @click="lookClick(scope.row.id)">详情</span>
                <span class="btn" @click="editClick(scope.row.id)">编辑</span>
                <span class="btn delClass" @click="delClick(scope.row.id)">删除</span>
                <!--                <img alt="" src="../../assets/img/161@2x.png" @click="editClick(scope.row.id)">-->
                <!--                <img alt="" src="../../assets/img/163@2x.png" @click="delClick(scope.row.id)">-->
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pag">
          <el-pagination v-model:page-size="pageSize" :page-sizes="[10, 20, 50, 100]" :total="total" background
                         layout="total,sizes,prev, pager, next" small @size-change="handleSizeChange"
                         @current-change="pageChange"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
//这里可以导入其他文件(比如:组件,工具js,第三方插件js,json文件,图片文件等等)
//例如:import 《组件名称》 from '《组件路径》';
import {h, onMounted, reactive, ref} from "vue"
import './electrovalence.less'
import {Back, Plus} from '@element-plus/icons-vue'
import {CascaderProps, ElMessage, ElMessageBox} from 'element-plus'
import {useRouter} from 'vue-router';
import {getListApi, editListApi, delListApi} from '@/api/modules/electrovalence'
import qs from "qs";

let router = useRouter()
// 返回
const goBack = function () {
  router.push('/admin/electrovalence')
}

// 电价-----------------------------------------------------------------------
// 分页
let pageNumber = ref(1)
let pageSize = ref(20)
let total = ref()
// 更改每页多少
const handleSizeChange = function (e) {
  pageSize.value = e
  getListFun()
}
// 跳转到某页
const pageChange = function (e) {
  pageNumber.value = e
  getListFun()
}
// 电价表格数据
let tableData = ref([])
// 获取电价列表
let loading = ref(false)
const getListFun = function () {
  loading.value = true
  getListApi(qs.stringify({
    pageNumber: pageNumber.value,
    pageSize: pageSize.value,
  })).then(res => {
    loading.value = false
    if (res.data.code === 0) {
      tableData.value = res.data.result.list
      total.value = Number(res.data.result.total)

    } else {
      ElMessage({
        message: res.data.message,
        type: 'error'
      })
    }
  }).catch(err => {
    console.log(err);
  })
}

// 新增电价点击
const addClick = function () {
  router.push('/admin/editVersion')
}
// 编辑点击
const editClick = function (id) {
  router.push({
    path: '/admin/editVersion',
    query: {id: id}
  })
}
// 查看详情
const lookClick = function (id) {
  router.push({
    path: '/admin/versionDetail',
    query: {id: id}
  })
}
// 删除电价
const delClick = function (id) {
  ElMessageBox.confirm('', '', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    title: '删除电价',
    message: h('p', null, [
      h('img', {
        src: 'https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/info.png',
        style: 'width:20px;height:20px;transform: translateY(4px);margin-right:8px;'
      }, ''),
      h('span', {style: 'color:#595959;'}, '请确认是否要删除此电价，删除后数据不可恢复'),
    ])
  }).then(() => {
    delListApi(qs.stringify({
      id: id
    })).then(res => {
      if (res.data.code === 0) {
        ElMessage({
          type: 'success',
          message: '删除成功',
        })
        getListFun()
      } else {
        ElMessage({
          type: 'error',
          message: res.data.message,
        })
      }
    }).catch(err => {
      console.log(err);
    })
  }).catch(() => {
    ElMessage({
      type: 'info',
      message: '取消删除',
    })
  })
}

onMounted(() => {
  getListFun()
})
</script>

<style lang="less" scoped>
</style>
